import { useState, useEffect } from 'react';
import { TextScramble } from '@/components/ui/text-scramble';

interface ScrambleCycleProps {
  texts: string[];
  interval?: number;
  duration?: number;
  speed?: number;
  className?: string;
}

export function ScrambleCycle({
  texts,
  interval = 3500,
  duration = 0.8,
  speed = 0.04,
  className,
}: ScrambleCycleProps) {
  const [index, setIndex] = useState(0);
  const [trigger, setTrigger] = useState(true);

  useEffect(() => {
    if (texts.length <= 1) return;
    const id = setInterval(() => {
      setIndex((prev) => (prev + 1) % texts.length);
      setTrigger(true);
    }, interval);
    return () => clearInterval(id);
  }, [texts, interval]);

  return (
    <TextScramble
      as="span"
      className={className}
      trigger={trigger}
      duration={duration}
      speed={speed}
      onScrambleComplete={() => setTrigger(false)}
    >
      {texts[index]}
    </TextScramble>
  );
}
